import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";
import { Role } from "core-fe-lib/openapi/core/models/Role";

export function pipelineRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/pipeline",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "runs",
            name: "pipeline-runs",
            component: () =>
              import("@/modules/pipeline/pages/PipelineRunsPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "runs/:runId",
            name: "pipeline-run-detail",
            component: () =>
              import("@/modules/pipeline/pages/PipelineRunDetailPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "batches/:batchId",
            name: "pipeline-batch-detail",
            component: () =>
              import("@/modules/pipeline/pages/PipelineBatchPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "llm-pricing",
            name: "pipeline-llm-pricing",
            component: () =>
              import("@/modules/pipeline/pages/LLMPricingPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "llm-pricing/new",
            name: "pipeline-llm-pricing-new",
            component: () =>
              import("@/modules/pipeline/pages/LLMPricingEditPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "llm-pricing/:id/edit",
            name: "pipeline-llm-pricing-edit",
            component: () =>
              import("@/modules/pipeline/pages/LLMPricingEditPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "cost",
            name: "pipeline-cost",
            component: () =>
              import("@/modules/pipeline/pages/CostDashboardPage.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
          {
            path: "seed",
            name: "pipeline-seed",
            component: () => import("@/modules/pipeline/pages/SeedPage.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
        ],
      },
    ],
  };
}
